var ObjectToString = Object.prototype.toString
var isArray : typeof Array.isArray
if (typeof Array.isArray === 'function') {
	isArray = Array.isArray
}else{
	isArray = function (arr) : arr is any[] {
		if (!arr) {
			return false
		}
		return ObjectToString.call(arr) === '[object Array]'
	}
}

export default isArray